import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useMapGetter } from 'dashboard/composables/store';
import { useWhatsappBrowserChannel } from 'dashboard/composables/useWhatsappBrowserChannel';

/**
 * Channel catalog rows for connect flow (same copy as ChannelList cards).
 * @returns {import('vue').ComputedRef<Array<{ key: string, title: string, description: string, svgSlug: string|null, icon: string }>>}
 */
export function useChannelConnectDefinitions() {
  const { t } = useI18n();
  const globalConfig = useMapGetter('globalConfig/get');
  const { whatsappBrowserEnabled } = useWhatsappBrowserChannel();

  return computed(() => {
    const { apiChannelName } = globalConfig.value;
    const channels = [
      {
        key: 'facebook',
        title: t('INBOX_MGMT.ADD.AUTH.CHANNEL.FACEBOOK.TITLE'),
        description: t('INBOX_MGMT.ADD.AUTH.CHANNEL.FACEBOOK.DESCRIPTION'),
        svgSlug: 'facebook',
        icon: 'i-woot-messenger',
      },
      {
        key: 'tiktok',
        title: t('INBOX_MGMT.ADD.AUTH.CHANNEL.TIKTOK.TITLE'),
        description: t('INBOX_MGMT.ADD.AUTH.CHANNEL.TIKTOK.DESCRIPTION'),
        svgSlug: 'tiktok',
        icon: 'i-woot-tiktok',
      },
      {
        key: 'whatsapp',
        title: t('INBOX_MGMT.ADD.AUTH.CHANNEL.WHATSAPP.TITLE'),
        description: t('INBOX_MGMT.ADD.AUTH.CHANNEL.WHATSAPP.DESCRIPTION'),
        svgSlug: 'whatsapp_business',
        icon: 'i-woot-whatsapp',
      },
      {
        key: 'instagram',
        title: t('INBOX_MGMT.ADD.AUTH.CHANNEL.INSTAGRAM.TITLE'),
        description: t('INBOX_MGMT.ADD.AUTH.CHANNEL.INSTAGRAM.DESCRIPTION'),
        svgSlug: 'instagram',
        icon: 'i-woot-instagram',
      },
      {
        key: 'telegram',
        title: t('INBOX_MGMT.ADD.AUTH.CHANNEL.TELEGRAM.TITLE'),
        description: t('INBOX_MGMT.ADD.AUTH.CHANNEL.TELEGRAM.DESCRIPTION'),
        svgSlug: 'telegram',
        icon: 'i-woot-telegram',
      },
      {
        key: 'line',
        title: t('INBOX_MGMT.ADD.AUTH.CHANNEL.LINE.TITLE'),
        description: t('INBOX_MGMT.ADD.AUTH.CHANNEL.LINE.DESCRIPTION'),
        svgSlug: 'line',
        icon: 'i-woot-line',
      },
      {
        key: 'api',
        title: apiChannelName || t('INBOX_MGMT.ADD.AUTH.CHANNEL.API.TITLE'),
        description: t('INBOX_MGMT.ADD.AUTH.CHANNEL.API.DESCRIPTION'),
        svgSlug: 'custom_channel',
        icon: 'i-woot-api',
      },
      {
        key: 'website',
        title: t('INBOX_MGMT.ADD.AUTH.CHANNEL.WEBSITE.TITLE'),
        description: t('INBOX_MGMT.ADD.AUTH.CHANNEL.WEBSITE.DESCRIPTION'),
        svgSlug: 'webchat',
        icon: 'i-woot-website',
      },
      {
        key: 'whatsapp_browser',
        title: t('INBOX_MGMT.ADD.AUTH.CHANNEL.WHATSAPP_BROWSER.TITLE'),
        description: t(
          'INBOX_MGMT.ADD.AUTH.CHANNEL.WHATSAPP_BROWSER.DESCRIPTION'
        ),
        svgSlug: 'whatsapp_business',
        icon: 'i-woot-whatsapp',
      },
      {
        key: 'sms',
        title: t('INBOX_MGMT.ADD.AUTH.CHANNEL.SMS.TITLE'),
        description: t('INBOX_MGMT.ADD.AUTH.CHANNEL.SMS.DESCRIPTION'),
        svgSlug: null,
        icon: 'i-woot-sms',
      },
      {
        key: 'email',
        title: t('INBOX_MGMT.ADD.AUTH.CHANNEL.EMAIL.TITLE'),
        description: t('INBOX_MGMT.ADD.AUTH.CHANNEL.EMAIL.DESCRIPTION'),
        svgSlug: 'other_email',
        icon: 'i-woot-mail',
      },
      {
        key: 'voice',
        title: t('INBOX_MGMT.ADD.AUTH.CHANNEL.VOICE.TITLE'),
        description: t('INBOX_MGMT.ADD.AUTH.CHANNEL.VOICE.DESCRIPTION'),
        svgSlug: null,
        icon: 'i-woot-voice',
      },
    ];

    if (!whatsappBrowserEnabled.value) {
      return channels.filter(ch => ch.key !== 'whatsapp_browser');
    }

    return channels;
  });
}
